import gsap, { Power3 } from 'gsap'
import showtimes from 'site/showtimes'
let showtimesSidebar = {
    init:function () {
        var self = this;
        $('#showtimes-sidebar .btn-close').click(showtimesSidebar.overlayHide);
        $(document).keyup(function(e) {
            if (e.keyCode === 27) { // escape key
                showtimesSidebar.overlayHide();
            }
        })
        showtimesSidebar.overlayHide();
        $('.showtimes-sidebar-hook').click(showtimesSidebar.showtimesSidebarClick);
        $('#search-form').on('submit',showtimesSidebar.submitSearch);

        $(window).on( "resize", showtimesSidebar.resize);


        // AUTO OPEN
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)
        const isVodAutoOpen = params.get('vod')
        const isQaAutoOpen = params.get('screenings')
        const isShowtimesAutoOpen = params.get('showtimes')
        if (isVodAutoOpen !== null) {
            showtimesSidebar.showtimesSidebarVodAutoOpen()
        } else if (isQaAutoOpen !== null) {
            showtimesSidebar.showtimesSidebarQaAutoOpen()
        } else if (isShowtimesAutoOpen !== null) {
            showtimesSidebar.showtimesSidebarShowtimesAutoOpen()
        }
    },//init

    resize () {
        // const h1Outer = $('#film-nav-overlay .mobile-content1').height()
        // const h2Outer = $('#film-nav-overlay .mobile-content2').height()
        //
        // // better centering of content in scroll or no scroll situation
        // if (h2Outer > h1Outer) {
        //     $('#film-nav-overlay .mobile-content1').addClass('block')
        // } else {
        //     $('#film-nav-overlay .mobile-content1').removeClass('block')
        // }
    },

    submitSearch: function (e) {
        let term = String($('#search-input').val())
        term = term.trim()
        if (term !== '') {
            if (!globalCookiesDisabledOptOut) {
                gtag('event', 'Action', {
                    'event_category': site_segment1,
                    'event_label': 'Search',
                    'value': term
                })
            }
            $('#search-form').submit()
        } else {
            e.preventDefault()
        }
    },

    showtimesSidebarVodAutoOpen() {
        $('.showtimes-sidebar-hook-vod').trigger('click')
    },
    showtimesSidebarQaAutoOpen() {
        $('.showtimes-sidebar-hook-qa').trigger('click')
    },
    showtimesSidebarShowtimesAutoOpen() {
        const el0 = $('.showtimes-sidebar-hook-showtimes-0');

        if (el0.length) {
            el0.trigger('click');
        } else {
            $('.showtimes-sidebar-hook-showtimes').first().trigger('click');
        }
    },

    showtimesSidebarClick: function() {
        showtimesSidebar.showtimesSidebarClick2($(this))
    },

    showtimesSidebarClick2: function(t) {
        let showtimesId = t.attr('data-showtimes-id')
        let showtimesTitle = t.attr('data-showtimes-title')
        let showtimesUseHtml = t.attr('data-showtimes-usehtml')
        showtimes.currentLoadedFilm = showtimesTitle
        sidebarOpen(showtimesTitle)

        $('#buy-hook-bugs').html('')

        if (showtimesUseHtml === '1') {
            $('#showtimes-sidebar .usehtml').show()
            $('#showtimes-sidebar .nousehtml').hide()

            showtimes.timesShow()

            let thtml = $('.usehtml .top', t).html()
            let bhtml = $('.usehtml .bottom', t).html()
            $('#showtimes-sidebar .top .usehtml').html(thtml)
            $('#buy-hook-bugs').html(bhtml)

        } else {
            $('#showtimes-sidebar .usehtml').hide()
            $('#showtimes-sidebar .nousehtml').show()
            $('#showtimes-sidebar-title').html(showtimesTitle)
            showtimes.timesHide()
            showtimes.init(showtimesId)
        }
        showtimesSidebar.overlayShow()
    },

    doHamburerToggle:function(){
        if ($(this).hasClass('is-active')) {
            showtimesSidebar.overlayHide();
        } else {
            showtimesSidebar.overlayShow();
        }
    },//doHamburerToggle

    subNavToggle:function() {
        if ($(this).hasClass('open')) {
            showtimesSidebar.subNavClose();
        } else {
            showtimesSidebar.subNavOpen(this);
        }
    },
    subNavOpen:function(t) {
        showtimesSidebar.subNavClose();
        $(t).addClass('open');
    },
    subNavClose:function() {
        $('#mobile-nav-overlay .header-2-nav-item-a').removeClass('open');
    },
    overlayShow:function() {
        //const mode = siteCommon.scGetSiteMode()
        let docWidth = $(window).width()
        if (docWidth <= 800) {
            //$('body').addClass('no-scroll')
        }

        $('#showtimes-sidebar').removeClass('hidden');
        let tl = gsap.timeline({})

        showtimesSidebar.resize()
        // Lock body scroll without jumping to top
        const scrollY = window.scrollY || window.pageYOffset || 0
        $('body').attr('data-scroll-y', String(scrollY))
        $('body').css('top', `-${scrollY}px`)
        $('body').addClass('no-scroll')
    },
    overlayHide:function() {
        $('#showtimes-sidebar').addClass('hidden');

        showtimesSidebar.resize()
        // Restore body scroll position
        const scrollYStr = $('body').attr('data-scroll-y')
        const prevScrollY = parseInt(scrollYStr || '0', 10) || 0
        $('body').removeClass('no-scroll')
        $('body').css('top', '')
        $('body').removeAttr('data-scroll-y')
        window.scrollTo(0, prevScrollY)
    },

}; //obj
export default showtimesSidebar
